module.exports = __webpack_public_path__ + "img/product28802p.e8126134.png";